import { render, staticRenderFns } from "./face-mobile.vue?vue&type=template&id=35176b11&"
import script from "./face-mobile.vue?vue&type=script&lang=js&"
export * from "./face-mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports